// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1-aMf","Success":"Button_Success__2eQyz","Danger":"Button_Danger__1iUKK"};